import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';
import { debounceTime, filter, map, Observable, Subject, takeUntil } from 'rxjs';
import { App_FormFieldDrawing, App_TrueField } from 'src/app/utils/interfaces';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'app-c-drawing',
  templateUrl: './c-drawing.component.html',
  styleUrls: ['./c-drawing.component.scss'],
})
export class CDrawingComponent implements OnInit, OnDestroy {
  @Input({ required: true }) field!: App_FormFieldDrawing;
  @Input({ required: true }) cFormControl!: FormControl;
  @Input({ required: true }) blocName!: string;
  @Input({ required: true }) disabledField!: boolean;
  @Input() asyncLabel: Observable<string> | undefined;
  @ViewChild('canvas', { static: true }) signaturePadElement!: ElementRef;
  @Input() etatId?: number;
  @Output() triggerAlert = new EventEmitter<{
    blocName: string;
    fieldName: string;
    fieldFormControl: AbstractControl<any, any>;
    field: App_TrueField;
  }>();

  signaturePad!: SignaturePad;
  eventListenerOrEventListenerObject: EventListenerOrEventListenerObject = () => this.updateControl()
  nonEventListenerOrEventListenerObject: EventListenerOrEventListenerObject = () => this.cancelUpdateControl()
  canvasBackground = '"- SIGNEZ ICI AVEC VOTRE DOIGT -"'

  destroyComponent$: Subject<boolean> = new Subject();

  constructor() { }

  ngOnInit() {
    this.signaturePad = new SignaturePad(this.signaturePadElement.nativeElement);

    if (this.cFormControl.value) {
      this.signaturePad.fromDataURL(this.cFormControl.value)
    }
    if (this.disabledField) {
      this.signaturePad.addEventListener('endStroke', this.nonEventListenerOrEventListenerObject);
    } else {
      this.signaturePad.addEventListener('endStroke', this.eventListenerOrEventListenerObject);
    }
    this.addAlertSubscriptions();
  }

  ngOnDestroy() {
    this.destroyComponent$.next(true);
  }

  updateControl() {
    const data = this.signaturePad.toDataURL();
    this.cFormControl.setValue(data);
    this.cFormControl.markAsDirty();
  }

  cancelUpdateControl() {
    this.signaturePad.clear();
    this.signaturePad.fromDataURL(this.cFormControl.value)
  }

  onRAZClick() {
    // this.alertController.create({
    //   message: `Effacer la saisie de la signature ?`,
    //   buttons: [
    //     {
    //       text: `NON`,
    //     },
    //     {
    //       text: `OUI`,
          // handler: () => {
      this.signaturePad.clear();
      this.cFormControl.setValue('');
      this.cFormControl.markAsDirty();
    //       }
    //     }
    //   ]
    // }).then(alrt => alrt.present());
  }

  addAlertSubscriptions() {
    const checkValidity = this.field.checkValidity;
    if (checkValidity !== undefined) {
      const validators = Array.isArray(checkValidity.validators)
      ? checkValidity.validators
      : [];
      const asyncValidators = Array.isArray(checkValidity.asyncValidators)
      ? checkValidity.asyncValidators
      : [];
      const allValidators = [
        ...validators,
        ...asyncValidators
      ];
      const validatorsWithTriggerAlert = allValidators.filter(validator => validator.triggerAlert);
      if (validatorsWithTriggerAlert.length > 0) {
        this.cFormControl.statusChanges.pipe(
          takeUntil(this.destroyComponent$),          
          debounceTime(200),
          filter(status => status === 'INVALID'),
          map(_ => {
            const errors = this.cFormControl.errors;
            if (errors !== null && (validatorsWithTriggerAlert.find(validator => errors[validator.type]) || (errors['err'] !== undefined && errors['err'][`type`] !== undefined && validatorsWithTriggerAlert.find(validator => errors['err'][`type`] === validator.type)))) {
              return errors;
            }
            return null;
          }),
          filter(_ => _ !== null),
        ).subscribe(errors => {
          this.triggerAlert.emit({
            blocName: this.blocName,
            fieldName: this.field.name,
            fieldFormControl: this.cFormControl,
            field: this.field,
          });
        })
      }
    }
  }


}
